import * as _ from 'lodash';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class FinalPrepCheckCtrl {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public tableRows;
  public options;
  private filteredStudents;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.tableRows = this.populateTableRows(this.filteredStudents);
    this.options = {
      columnKeys: ['cohort', 'gradPlan', 'regentsSchedForNextAdmin', 'currentlyActiveSupports'],
    };
  }

  private populateTableRows = students => {
    const tableRows = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    };
    _.each(students, (student: any) => {
      const { studentId, countOfCurrentlyActiveSupports } = student;
      if (countOfCurrentlyActiveSupports === 1) {
        tableRows[1].push(studentId);
      } else if (countOfCurrentlyActiveSupports === 2) {
        tableRows[2].push(studentId);
      } else if (countOfCurrentlyActiveSupports === 3) {
        tableRows[3].push(studentId);
      } else if (countOfCurrentlyActiveSupports === 4) {
        tableRows[4].push(studentId);
      } else if (countOfCurrentlyActiveSupports >= 5) {
        tableRows[5].push(studentId);
      }
    });
    return tableRows;
  };
}
